import { useMailboxesStore } from '../../Providers/Stores/MailboxesStore';
import { MailTagCollectionType } from './Types/MailTagTypes';
import { MailTagOverflowed } from './Entries/MailTagOverflowed';
import { MailTag } from './Entries/MailTag';

function MapMailTags(props: MailTagCollectionType) {
	const mailBoxInfo = useMailboxesStore((state) => state.mailBoxInfo);

	const newTags = [];
	let manualTagId = -1;

	for (const currentTag of props.tags) {
		if (currentTag.id === mailBoxInfo.mailTagIds) {
			manualTagId = currentTag.id;

			newTags.unshift(
				<MailTag
					key={`mail-item-tag-${props.mailUuid}-${currentTag.id}`}
					id={currentTag.id}
					name={currentTag.labelName}
					tagCount={props.tags.length}
					hideIcon={false}
					small={props.small || false}
					removeCallback={props.removeCallback}
				/>,
			);

			if (props.displayLimit && newTags.length > props.displayLimit) {
				newTags.pop();
				break;
			}
		}

		if (newTags.length < (props.displayLimit || props.tags.length)) {
			if (currentTag.id !== manualTagId) {
				newTags.push(
					<MailTag
						key={`mail-item-tag-${props.mailUuid}-${currentTag.id}`}
						id={currentTag.id}
						name={currentTag.labelName}
						tagCount={props.tags.length}
						hideIcon={false}
						small={props.small || false}
						removeCallback={props.removeCallback}
					/>,
				);
			}
		}
	}

	if (newTags.length < props.tags.length) {
		newTags.push(
			<MailTagOverflowed
				key={`mail-item-tag-overflow-${props.mailUuid}-${props.tags.length}`}
				id={767976467}
				name='All Tags'
				tagCount={props.tags.length - newTags.length}
				hideIcon
				small={props.small || false}
			/>,
		);
	}

	// eslint-disable-next-line react/jsx-no-useless-fragment
	return <>{newTags}</>;
}

export { MapMailTags };
